<template>
  <div>
    <PerfectScrollbar class="AllPwaMobile">
      <div class="AllMessageTicket">
        <form style="direction: rtl" @submit.prevent="submitTicket">
          <div>
            <div class="ShowVGLatest1">
              <h3>{{ $t('ticket.view.ticketText') }}</h3>

              <div style="margin-top: 10px; cursor: pointer" @click="deleteBtn">
                <VsxIcon iconName="CloseCircle" :size="32" :color="color" type="linear" />
              </div>
            </div>

            <textarea class="textareaMessage" v-model="message" id="message" :placeholder="$t('ticket.view.ticketText')"></textarea>
          </div>

          <div style="margin-top: 20px">
            <label class="imageMarginTopStyle" style="margin-bottom: 10px" for="images">{{ $t('ticket.view.images') }}:</label>

            <div class="imageForFileInput" v-for="(fileInput, index) in fileInputs" :key="index">
              <input class="InputStyleMarginTop" type="file" @change="onFileChange($event, index)" accept="image/*" />
              <button class="buttonSubmitClass2" type="button" @click="removeFileInput(index)">{{ $t('ticket.view.remove') }}</button>
            </div>

            <button class="buttonSubmitClass3" type="button" @click="addFileInput">{{ $t('ticket.view.addImage') }}</button>
          </div>

          <div v-if="selectedFiles.length">
            <h4>{{ $t('ticket.view.selectedImages') }}:</h4>
            <ul>
              <li v-for="(file, index) in selectedFiles" :key="index">
                {{ file.name }} <button class="buttonSubmitClass2" style="width: auto !important; padding: 0 10px !important;" type="button" @click="removeSelectedFile(index)">{{ $t('ticket.view.remove') }}</button>
              </li>
            </ul>
          </div>

          <button class="buttonSubmitClass1" type="submit" :disabled="isLoading">{{ isLoading ? $t('ticket.view.sending') : $t('ticket.view.send') }}</button>
        </form>

        <div class="upload-restrictions">
          <h4>{{ $t('ticket.view.uploadRules.title') }}</h4>
          <p>{{ $t('ticket.view.uploadRules.maxFiles') }}</p>
          <p>{{ $t('ticket.view.uploadRules.allowedExtensions') }}</p>
        </div>

        <h3 class="ShowVGLatest">{{ $t('ticket.view.previousMessages') }}</h3>

        <div>
          <div v-for="(msg, index) in previousMessages[1]" :key="index" class="previous-message">
            <div class="previousMessageIndex">
              <p>{{ msg.admin_id ? $t('ticket.view.admin') : $t('ticket.view.user') }}:</p>
              <span>{{ msg.message }}</span>
            </div>
            <p><strong>{{ $t('ticket.view.sentDate') }}:</strong> {{ formatDate(msg.created_at) }}</p>

            <div v-if="msg.attachments.length > 0">
              <p>{{ $t('ticket.view.attachments') }}:</p>
              <ul>
                <li v-for="(attachment, imgIndex) in msg.attachments" :key="imgIndex">
                  <a :href="downloadUrl(attachment.id)" target="_blank">
                    {{ $t('ticket.view.sentImage') }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </PerfectScrollbar>
  </div>
</template>

<script>
import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
import axios from "@/axios";
import {toast} from "vue3-toastify"; // فرض بر این است که axios را در پروژه خود نصب کرده‌اید

export default {
  name: "TicketUserComponent",
  components: {
    PerfectScrollbar,
  },
  data() {
    return {
      color: localStorage.getItem('theme') === 'dark' ? '#BB86FC' : '#2E1977',
      message: '',
      selectedFiles: [],
      fileInputs: [0], // آرایه برای ورودی‌های فایل
      previousMessages: [], // آرایه برای ذخیره پیام‌های قبلی
      isLoading: false // وضعیت بارگذاری
    };
  },
  mounted() {
    this.loadPreviousMessages();
    setInterval(() => {
      this.loadTheme()
    }, 100);
  },
  methods: {
    downloadUrl(id) {
      const baseUrl = this.$store.state.url;
      return `${baseUrl}/download1/${id}`;
    },
    addFileInput() {
      this.fileInputs.push(this.fileInputs.length); // اضافه کردن ورودی جدید
    },
    removeFileInput(index) {
      this.fileInputs.splice(index, 1); // حذف ورودی فایل
    },
    onFileChange(event, index) {
      const file = event.target.files[0]; // دریافت فایل انتخاب شده
      if (file) {
        this.selectedFiles[index] = file; // ذخیره فایل در آرایه selectedFiles
      }
    },
    removeSelectedFile(index) {
      this.selectedFiles.splice(index, 1); // حذف فایل انتخاب شده
    },
    async submitTicket() {
      if (!this.message) {
        toast(this.$t('ticket.errors.enterMessage'), {
          autoClose: 3000,
          position: "top-right",
          type: "error",
        });
        return;
      }

      const userData = localStorage.getItem('user');
      const userData1 = JSON.parse(userData);

      const formData = new FormData();
      formData.append('user_id', userData1.id);
      formData.append('message', this.message);
      formData.append('ticket', this.$route.params.id);

      this.selectedFiles.forEach(file => {
        if (file) {
          formData.append('attachments[]', file); // اضافه کردن هر فایل به FormData
        }
      });

      this.isLoading = true;

      try {
        const response = await axios.post('/ticket-message', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (response.data[0] == "success") {
          this.message = '';
          this.selectedFiles = [];
          this.fileInputs = [0];
          this.loadPreviousMessages();
          toast(this.$t('ticket.success.sent'), {
            autoClose: 3000,
            position: "top-right",
            type: "success",
          });
        }
      } catch (error) {
        console.error('Error sending ticket:', error);
      } finally {
        this.isLoading = false;
      }
    },
    async loadPreviousMessages() {
      const userData = localStorage.getItem('user');
      const userData1 = JSON.parse(userData);

      let attempts = 0;
      const maxAttempts = 10;
      const delay = 100;
      while (attempts < maxAttempts) {
        try {
          const response = await axios.post('/ticket-get' , {
            user_id : userData1.id,
            ticket : this.$route.params.id,
          });

          this.previousMessages = response.data
          return;

        } catch (error) {
          if (error.response) {
            const errors = error.response.data.errors;

            const keys = Object.keys(errors);
            for (const key of keys) {
              toast(errors[key].join(', '), {
                autoClose: 3000,
                position: "top-right",
                type: "error",
              });
            }
            return;
          } else {
            console.error('An unexpected error occurred:', error.message);
          }
        }

        attempts++;
        await new Promise(resolve => setTimeout(resolve, delay));
      }
    },
    formatDate(dateString) {
      const options = { year: 'numeric', month: 'long', day: 'numeric', weekday: 'long', hour: '2-digit', minute: '2-digit' };
      return new Date(dateString).toLocaleDateString('fa-IR', options);
    },
    async deleteBtn(){
      const result = await this.$swal({
        title: this.$t('ticket.view.close.confirmTitle'),
        text: this.$t('ticket.view.close.confirmText'),
        showCancelButton: true,
        confirmButtonText: this.$t('ticket.view.close.closeButton'),
        confirmButtonAriaLabel: "Thumbs up, great!",
        cancelButtonText: this.$t('ticket.view.close.cancelButton'),
        cancelButtonAriaLabel: "Thumbs down"
      });

      if (result.value == true) {

        const userData = localStorage.getItem('user');
        const userData1 = JSON.parse(userData);

          let attempts = 0;
          const maxAttempts = 10;
          const delay = 100;
          while (attempts < maxAttempts) {
            try {
              const responsive = await axios.post('/close-ticket' , {
                user_id : userData1.id,
                ticket : this.$route.params.id,
              });

              if (responsive.data[0] == "success"){
                this.loadPreviousMessages()
                toast(this.$t('ticket.view.close.success'), {
                  autoClose: 3000,
                  position: "top-right",
                  type: "success",
                });
              }else{
                toast(this.$t('ticket.view.close.error'), {
                  autoClose: 3000,
                  position: "top-right",
                  type: "error",
                });
              }

              return;
            } catch (error) {
              console.log('error')
            }

            attempts++;
            await new Promise(resolve => setTimeout(resolve, delay));
        }
      }
    },

    loadTheme() {
      const savedTheme = localStorage.getItem('theme');
      if( savedTheme == "light"){
        this.color = '#2E1977'
      }else{
        this.color = '#BB86FC'
      }
    }
  }
};
</script>

<style scoped>

</style>